module.exports = __webpack_public_path__ + "img/tele2-succes-image.40a912e1.png";